"use strict";
/*
 * Created on 5. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");
/**
 * Company vs. competitor reference price (CRP) change index.
 * @author Radek Beran
 */


var CompanyVsCRPChangeIndex =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompanyVsCRPChangeIndex, _DomainObject_1$Domai);

  /**
   * @param value value of this price change index
   * @param crpValue value of CRP price - price the index is computed from
   * @param competitorId competitor id
   * @param validationResult validation messages
   */
  function CompanyVsCRPChangeIndex(value, crpValue, competitorId, validationResult) {
    var _this;

    _classCallCheck(this, CompanyVsCRPChangeIndex);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompanyVsCRPChangeIndex).call(this));
    _this.value = value;
    _this.crpValue = crpValue;
    _this.competitorId = competitorId;
    _this.validationResult = validationResult;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to price change index.
   */


  _createClass(CompanyVsCRPChangeIndex, [{
    key: "withValidationResult",
    value: function withValidationResult(validationResult) {
      return this.copy('validationResult', validationResult);
    }
  }, {
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObjectIfNotPresent(message));
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new CompanyVsCRPChangeIndex(mat.value, mat.crpValue, mat.competitorId, mat.validationResult);
    }
  }]);

  return CompanyVsCRPChangeIndex;
}(DomainObject_1.DomainObject);

exports.CompanyVsCRPChangeIndex = CompanyVsCRPChangeIndex;

CompanyVsCRPChangeIndex.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompanyVsCRPChangeIndex.name);
  return {
    value: builder.bigNum('value'),
    crpValue: builder.bigNum('crpValue'),
    competitorId: builder.str('competitorId'),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();